export const CurrencyFormatWithSign = (num:string,sign:string,rtl:boolean,lang:string)=>{
    return (
        (!rtl ? sign : '')+
        CurrencyFormat(num) +
        (rtl ? (' '+sign):'')
    );
};

export const CurrencyFormat = (num:string|number) => {
    let y = typeof num === 'string' ? num : num.toString();
    const x = y.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    return ToxicDigitsAuto(x,'fa');
}

export const ToxicDigitsAuto = (num:string,lang:string) => {
    const faDigits = '۰۱۲۳۴۵۶۷۸۹'.split("");
    if (lang === 'fa' || lang === 'ar')
        return num.split('').map((e:string) => {
            const i = parseInt(e);
            return typeof faDigits[i] !== 'undefined' ? faDigits[i] : e;
        }).join('');
    else
        return num;
}

export const ToxicDigitsFixToEnglish = (num:string) => {
    let find = '۰۱۲۳۴۵۶۷۸۹'.split(""),
        replace = '0123456789'.split(""),
        regex,i=0;
    for (; i < find.length; i++) {
        regex = new RegExp(find[i], "g");
        num = num.replace(regex, replace[i]);
    }
    return num;
}

export const StringDigitsConvertToPersian = (str:string|number) => {
    let x = str.toString();
    let find = '0123456789'.split(""),
        replace = '۰۱۲۳۴۵۶۷۸۹'.split(""),
        regex,i=0;
    for (; i < find.length; i++) {
        regex = new RegExp(find[i], "g");
        x = x.replace(regex, replace[i]);
    }
    return x;
}

export const ToxicIntTryParse = (s:string) => {
    try {
        parseInt(s);
    } catch (e) {
        return false;
    }
    return true;
}

export const ToxicInputNumberOnly = (text: string): string => {
    let t = text.toString().trim();
    if (t === "" || t === "NaN") // todo use isNaN()
        return "";
    let e = ToxicDigitsFixToEnglish(t);

    return e.toString();
};

export const BankCardFormat = (cardNumber:string) => {
    let digitsOnly = cardNumber.replace(/\D/g, '');
    return digitsOnly.replace(/(\d{4})(?=\d)/g, '$1-');
};

export const ValidateCardNumber = (card: string, irCard: boolean) => {
    const cleanedCard = card.replace(/\D/g, "");
    const strlen = cleanedCard.length;
    const firstDigit = parseInt(cleanedCard.charAt(0), 10);

    if ((irCard && strlen !== 16) || (!irCard && (strlen < 13 || strlen > 19)) || ![2, 4, 5, 6, 9].includes(firstDigit))
        return false;

    const res = Array.from(cleanedCard, (digit, index) => {
        let num = parseInt(digit, 10);
        return (strlen % 2 === index % 2) ? ((num *= 2) > 9 ? num - 9 : num) : num;
    });

    return res.reduce((sum, digit) => sum + digit, 0) % 10 === 0;
};

export const NumberToPersianLetters = (num:number) => {
    const delimiter = ' و ';
    const zero = 'صفر';
    const negative = 'منفی ';
    const letters = [
        " یک دو سه چهار پنج شش هفت هشت نه".split(" "),
        "ده یازده دوازده سیزده چهارده پانزده شانزده هفده هجده نوزده بیست".split(" "),
        "  بیست سی چهل پنجاه شصت هفتاد هشتاد نود".split(" "),
        " یکصد دویست سیصد چهارصد پانصد ششصد هفتصد هشتصد نهصد".split(" "),
        ". هزار. میلیون. میلیارد. بیلیون. بیلیارد. تریلیون. تریلیارد. کوآدریلیون. کادریلیارد. کوینتیلیون. کوانتینیارد. سکستیلیون. سکستیلیارد. سپتیلیون. سپتیلیارد. اکتیلیون. اکتیلیارد. نانیلیون. نانیلیارد. دسیلیون. سسدسیلیارد".split("."),
    ];
    const decimalSuffixes = " دهم صدم هزارم ده‌هزارم صد‌هزارم میلیونوم ده‌میلیونوم صدمیلیونوم میلیاردم ده‌میلیاردم صد‌‌میلیاردم".split(" ");
    function prepareNumber(num: number) {
        let out = num.toString();
        if (out.length % 3 === 1)
            out = "00".concat(out);
        else if (out.length % 3 === 2)
            out = "0".concat(out);
        return out.replace(/\d{3}(?=\d)/g, '$&*').split('*');
    }
    function tinyNumToWord(num: string) {
        if (parseInt(num, 0) === 0)
            return '';
        let parsedInt = parseInt(num, 0);
        if (parsedInt < 10)
            return letters[0][parsedInt];
        if (parsedInt <= 20)
            return letters[1][parsedInt - 10];
        if (parsedInt < 100) {
            let _one = parsedInt % 10;
            let _ten = (parsedInt - _one) / 10;
            if (_one > 0)
                return letters[2][_ten] + delimiter + letters[0][_one];
            return letters[2][_ten];
        }
        let one = parsedInt % 10;
        let hundreds = (parsedInt - parsedInt % 100) / 100;
        let ten = (parsedInt - (hundreds * 100 + one)) / 10;
        let out = [letters[3][hundreds]];
        let secondPart = ten * 10 + one;
        if (secondPart === 0)
            return out.join(delimiter);
        if (secondPart < 10)
            out.push(letters[0][secondPart]);
        else if (secondPart <= 20)
            out.push(letters[1][secondPart - 10]);
        else {
            out.push(letters[2][ten]);
            if (one > 0)
                out.push(letters[0][one]);
        }
        return out.join(delimiter);
    };
    function convertDecimalPart(decimalPart: string) {
        decimalPart = decimalPart.replace(/0*$/, "");
        if (decimalPart === '')
            return '';
        if (decimalPart.length > 11)
            decimalPart = decimalPart.substr(0, 11);
        return ' ممیز ' + Num2persian(decimalPart) + ' ' + decimalSuffixes[decimalPart.length];
    }
    function Num2persian(input: string){
        input = input.toString().replace(/[^0-9.-]/g, '');
        let isNegative = false;
        let floatParse = parseFloat(input); // return zero if this isn't a valid number
        if (isNaN(floatParse))
            return zero;
        if (floatParse === 0)
            return zero;
        if (floatParse < 0) {
            isNegative = true;
            input = input.replace(/-/g, '');
        }
        let decimalPart = '';
        let integerPart = input;
        let pointIndex = input.indexOf('.'); // Check for float numbers form string and split Int/Dec
        if (pointIndex > -1) {
            integerPart = input.substring(0, pointIndex);
            decimalPart = input.substring(pointIndex + 1, input.length);
        }
        if (integerPart.length > 66)
            return 'خارج از محدوده';
        var slicedNumber = prepareNumber(parseInt(integerPart)); // Fetch Sections and convert
        var out = [];
        for (var i = 0; i < slicedNumber.length; i += 1) {
            var converted = tinyNumToWord(slicedNumber[i]);
            if (converted !== '')
                out.push(converted + letters[4][slicedNumber.length - (i + 1)]);
        }
        if (decimalPart.length > 0)
            decimalPart = convertDecimalPart(decimalPart);
        return (isNegative ? negative : '') + out.join(delimiter) + decimalPart;
    }
    return Num2persian(num.toString());
};

export const FixStringWithNumbers = (str:string) => {
    let x = str.toString();
    let find = '۰۱۲۳۴۵۶۷۸۹'.split(""),
        replace = '0123456789'.split(""),
        regex,i=0;
    for (; i < find.length; i++) {
        regex = new RegExp(find[i], "g");
        x = x.replace(regex, replace[i]);
    }
    return x;
};

export const CheckPhoneNumberFormat = (phone:string) => {
    const pattern = /^09\d{9}$/;
    return pattern.test(phone);
};